import { commonColors } from './common/colors';
import { createColors } from './create/colors';
import { libraryColors } from './library/colors';
import { lipSyncColors } from './lipSync/colors';
import { paymentModalColor } from './paymentModal/colors';
import { projectsColors } from './projects/colors';
export interface ThemeColors {
  color: {
    [key: string]: string;
  };
  backgroundColor: {
    [key: string]: string;
  };
  borderColor: {
    [key: string]: string;
  };
}

/**
 * 合并多个主题颜色对象。
 * @param {...ThemeColors} colorSets - 要合并的主题颜色对象。
 * @returns {ThemeColors} - 合并后的主题颜色对象。
 */
function mergeThemeColors(...colorSets: ThemeColors[]): ThemeColors {
  return colorSets.reduce(
    (acc, curr) => ({
      color: { ...acc.color, ...curr.color },
      backgroundColor: { ...acc.backgroundColor, ...curr.backgroundColor },
      borderColor: { ...acc.borderColor, ...curr.borderColor },
    }),
    {
      color: {},
      backgroundColor: {},
      borderColor: {},
    },
  );
}

export const themeColors = mergeThemeColors(
  createColors,
  commonColors,
  projectsColors,
  libraryColors,
  lipSyncColors,
  paymentModalColor,
);
